import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

function formatErr(d) {
  if (!d) return "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/library";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav(next);
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-[1360px] mx-auto px-6 lg:px-12 pt-16 pb-24 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-6 lg:pr-16">
        <p className="eyebrow">Return to your shelf</p>
        <h1 className="font-serif-display text-5xl sm:text-6xl leading-none tracking-tighter mt-6">
          Sign in.
        </h1>
        <p className="mt-6 text-[#5C5C5C] max-w-md leading-relaxed">
          Your library, your unfinished chapters, and your quiet correspondence — all waiting on the other side.
        </p>
      </div>
      <div className="lg:col-span-6">
        <form onSubmit={submit} className="max-w-md bg-white border border-[#E5E2DC] p-8">
          <label className="eyebrow block">Email</label>
          <input value={email} onChange={e=>setEmail(e.target.value)} type="email" required data-testid="login-email"
            className="mt-2 w-full bg-[#F9F8F6] border border-[#E5E2DC] px-3 py-3 text-sm outline-none focus:border-[#2A3B32]" />

          <label className="eyebrow block mt-6">Password</label>
          <input value={password} onChange={e=>setPassword(e.target.value)} type="password" required data-testid="login-password"
            className="mt-2 w-full bg-[#F9F8F6] border border-[#E5E2DC] px-3 py-3 text-sm outline-none focus:border-[#2A3B32]" />

          {error && <p className="mt-4 text-sm text-[#B85C38]" data-testid="login-error">{error}</p>}

          <button type="submit" data-testid="login-submit" disabled={loading} className="btn-primary w-full justify-center mt-8">
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <p className="mt-6 text-sm text-[#5C5C5C]">
            No account? <span className="text-[#5C5C5C]">You don't need one to buy — <Link to="/catalog" data-testid="link-catalog" className="link-underline text-[#1C1C1C]">browse the catalog</Link> and check out as a guest.</span>
          </p>
        </form>
      </div>
    </div>
  );
}
